import { JSONSchema7, JSONSchema7Definition } from 'json-schema';

export function flattenJSONSchema(
  schema: JSONSchema7,
  path?: string,
): {
  [key: string]: JSONSchema7;
} {
  let flattenedJson: {
    [key: string]: JSONSchema7;
  } = {};
  const targetProperties = schema ? schema.properties : {};

  const prefix = path ? path + '.' : '';

  for (const property in targetProperties) {
    const propSchema = targetProperties[property] as JSONSchema7;
    if (propSchema.type === 'array') {
      const { items: _, ...schemaWithoutProp } = propSchema;
      flattenedJson[prefix + property] = schemaWithoutProp;
      flattenedJson = {
        ...flattenedJson,
        ...flattenJSONSchema(
          // NOTE: propSchema.items의 타입을 강제했지만, array of Schema의 가능성도 존재함(배열 요소에 대한 2개 이상의 형태 허용 시).
          // 현 시스템에서 허용하지 않는 구조라 보류하였으나 추후 스펙 변경 시 해당부분 수정 필요
          propSchema.items as JSONSchema7Definition as JSONSchema7,
          prefix + property,
        ),
      };
    } else if (propSchema.type === 'object') {
      const { properties: _, ...schemaWithoutProp } = propSchema;
      flattenedJson[prefix + property] = schemaWithoutProp;
      flattenedJson = {
        ...flattenedJson,
        ...flattenJSONSchema(propSchema, prefix + property),
      };
    } else {
      flattenedJson[prefix + property] = propSchema;
    }
  }
  return flattenedJson;
}
